/**
 * @module geo/types
 */

/**
 * @hidden
 * @private
 */
export enum ServiceOperationState {
  pending = 'pending',
  done = 'done',
  exception = 'exception'
}